import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function MessagingPositioning({ messagingAndPositioning }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     core_brand_message: "b",
  //     value_proposition: "c",
  //     campaign_themes: "d",
  //     core_brand_message_positive_insight: "b",
  //     core_brand_message_negative_insight: "b",
  //     core_brand_message_recent_development: "b",
  //     value_proposition_positive_insight: "c",
  //     value_proposition_negative_insight: "c",
  //     value_proposition_recent_development: "c",
  //     campaign_themes_positive_insight: "d",
  //     campaign_themes_negative_insight: "d",
  //     campaign_themes_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     core_brand_message: "b",
  //     value_proposition: "c",
  //     campaign_themes: "d",
  //     core_brand_message_positive_insight: "b",
  //     core_brand_message_negative_insight: "b",
  //     core_brand_message_recent_development: "b",
  //     value_proposition_positive_insight: "c",
  //     value_proposition_negative_insight: "c",
  //     value_proposition_recent_development: "c",
  //     campaign_themes_positive_insight: "d",
  //     campaign_themes_negative_insight: "d",
  //     campaign_themes_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     core_brand_message: "b",
  //     value_proposition: "c",
  //     campaign_themes: "d",
  //     core_brand_message_positive_insight: "b",
  //     core_brand_message_negative_insight: "b",
  //     core_brand_message_recent_development: "b",
  //     value_proposition_positive_insight: "c",
  //     value_proposition_negative_insight: "c",
  //     value_proposition_recent_development: "c",
  //     campaign_themes_positive_insight: "d",
  //     campaign_themes_negative_insight: "d",
  //     campaign_themes_recent_development: "d",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(messagingAndPositioning);
    setTabData(tableData);
  }, [messagingAndPositioning]);

  const tableColumns = [
    // { key: "competitor", label: "Competitor" },
    { key: "core_brand_message", label: "Core Brand Message" },
    { key: "value_proposition", label: "Value Proposition" },
    { key: "campaign_themes", label: "Campaign Themes" },
  ];

  return (
    <InsightTable
      title="Messaging & Positioning"
      subtitle="Comparison of brand messaging, value propositions, and campaign themes shaping market perception across leading competitors."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default MessagingPositioning;
